module.exports = __webpack_public_path__ + "static/media/large-garden.6e9f752b.webp";